module.exports = __webpack_public_path__ + "img/bid01.9c34c7fb.png";